import styled from 'styled-components'
import { TypeBodyM, TypeCaptionL, TypeHeadingL, TypeHeadingXS } from '../../styles/mixins';
import LinkRender from '../link/LinkRender';
import LinkUnderline from '../link/LinkUnderline';
import SanityContent from './content/SanityContent';
import SanityImage from './SanityImage';

interface Props {
  card: any
  className?: string
}
const SanityRegeneration: React.FC<Props> = ({ 
  card,
  className,
}: Props) => {
  
  return (
    <Container className={className}>
      <Heading>
        <LinkRender href={card.link.href}>
          {card.title}
        </LinkRender>
      </Heading>
      <Description>
        <Caption layout="DEFAULT" blocks={card.image.caption} />
        <Link href={card.link.href}>
          Read More
        </Link>
      </Description>
      <Darken />
      <Image alt={card.image.alt || ''} image={card.image.image} ratio="2x3" />
    </Container>
  )
}

const Container = styled.div`
  display: grid;
`

const Content = styled.div`
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  display: flex;
  justify-content: space-around;
  z-index: 5;
  color: var(--color-background);
  pointer-events: none;
`

const Heading = styled(Content)`
  align-items: center;
  ${TypeHeadingL};
  a {
    pointer-events: auto;
  }
`

const Description = styled(Content)`
  align-items: flex-end;
  ${TypeHeadingXS};
  margin: var(--spacing-24);
  flex-direction: column;
`

const Caption = styled(SanityContent)`
  margin-top: auto;
`

const Link = styled(LinkUnderline)`
  ${TypeCaptionL};
  margin-right: auto;
  margin-top: var(--spacing-16);
  --LinkUnderline-color: var(--color-background);
  --LinkUnderline-hover-color: var(--color-background);
  pointer-events: auto;
`

const Darken = styled.div`
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  z-index: 2;
  background: rgba(0,0,0,0.15);
`

const Image = styled(SanityImage)`
  grid-column: 1 / 2;
  grid-row: 1 / 2;
`

export default SanityRegeneration